import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Search, LayoutGrid, List, Download } from 'lucide-react';
import ProtoMonthPicker from '@/components/zoho/proto/ProtoMonthPicker';

export default function ProtoFilterBar({ viewMode, onViewChange, search, onSearch, dept, onDept, rating, onRating, month, onMonth }) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3" data-testid="proto-filter-bar">
      <div className="relative flex-1 w-full sm:max-w-xs">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search by name or ID..."
          value={search}
          onChange={function(e) { onSearch(e.target.value); }}
          className="pl-9 h-9 text-sm"
          data-testid="proto-search-input"
        />
      </div>

      <Select value={dept} onValueChange={onDept}>
        <SelectTrigger className="w-[160px] h-9 text-sm" data-testid="proto-dept-filter">
          <SelectValue placeholder="Department" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Departments</SelectItem>
          <SelectItem value="Engineering">Engineering</SelectItem>
          <SelectItem value="Marketing">Marketing</SelectItem>
          <SelectItem value="Finance">Finance</SelectItem>
          <SelectItem value="Sales">Sales</SelectItem>
        </SelectContent>
      </Select>

      <Select value={rating} onValueChange={onRating}>
        <SelectTrigger className="w-[140px] h-9 text-sm" data-testid="proto-rating-filter">
          <SelectValue placeholder="Rating" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">All Ratings</SelectItem>
          <SelectItem value="5">5 Stars</SelectItem>
          <SelectItem value="4">4+ Stars</SelectItem>
          <SelectItem value="3">3+ Stars</SelectItem>
        </SelectContent>
      </Select>

      <ProtoMonthPicker value={month} onChange={onMonth} />

      <div className="flex items-center gap-2 ml-auto">
        <Button variant="outline" size="sm" className="h-9 gap-1.5 text-sm" data-testid="proto-export-btn">
          <Download className="h-3.5 w-3.5" /> Export
        </Button>
        <div className="flex border border-slate-200 rounded-lg overflow-hidden">
          <button
            onClick={function() { onViewChange('grid'); }}
            className={'p-2 transition-colors duration-150 ' + (viewMode === 'grid' ? 'bg-slate-900 text-white' : 'bg-white text-slate-500 hover:bg-slate-50')}
            data-testid="proto-view-grid"
          >
            <LayoutGrid className="h-4 w-4" />
          </button>
          <button
            onClick={function() { onViewChange('list'); }}
            className={'p-2 transition-colors duration-150 ' + (viewMode === 'list' ? 'bg-slate-900 text-white' : 'bg-white text-slate-500 hover:bg-slate-50')}
            data-testid="proto-view-list"
          >
            <List className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
